/** @jsxImportSource @emotion/react */
import { SignInHeader, SignInSubtitle } from 'components/partials'
import { TITLE_COLOR } from 'lib/constants'

const wrapperStyles = {
  marginLeft: '15%',
  padding: '8vh 6vw 0 6vw',
  maxWidth: '600px',
}

function OrgSuspendedPage() {
  return (
    <div css={wrapperStyles}>
      <SignInHeader>Organization Suspended</SignInHeader>
      <SignInSubtitle>
        This organization&apos;s account is currently suspended. Please select a different organization from the menu,
        or contact Client Success at client.success@reactmobile.com to resolve this account.
      </SignInSubtitle>
    </div>
  )
}

export default OrgSuspendedPage
